import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from 'reactstrap';

const DeleteInspectionConfirmationModal = ({ open, onClose, onDelete, inspection }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        try {
            setLoading(true);
            if (onDelete) await onDelete();
            onClose();
        } catch (error) {
            console.error('Delete failed:', error);
        } finally {
            setLoading(false);
        }
    };

    const year = inspection?.year || 'unknown year';
    const buildingName = inspection?.property?.buildingName || 'unknown building';
    const itemCount = inspection?.inspections?.length || 0;
    const itemLabel = itemCount === 1 ? 'inspection item' : 'inspection items';

    return (
        <Modal isOpen={open} toggle={onClose} centered className="inspection-tracker-dialog">
            <ModalHeader toggle={onClose}>Confirm Deletion</ModalHeader>
            <ModalBody>
                <p className="mb-0">
                    Are you sure you want to delete the Inspection Tracker record for{' '}
                    <strong>{buildingName}</strong> in <strong>{year}</strong>?
                    <br />
                    This record contains <strong>{itemCount} {itemLabel}</strong>.
                    <br />
                    <small className="text-muted">This action cannot be undone.</small>
                </p>
            </ModalBody>
            <ModalFooter>
                <Button outline color="secondary" onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button color="danger" onClick={handleConfirm} disabled={loading}>
                    {loading && <Spinner size="sm" className="me-2" />}
                    {loading ? 'Deleting...' : 'Delete Record'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export { DeleteInspectionConfirmationModal };